// extracted by mini-css-extract-plugin
export var cardLayout = "_77-1";
export var paginationContainer = "_77-0";